import * as React from 'react';
import { IAppPropsWithRoute } from '../../common/types';
import { withRouter } from 'react-router-dom';
import AddEditReasonWidget, { REASON_TYPE } from '../AddEditReason/AddEditReasonWidget';
import { useDispatch } from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';

interface ViewCustomersPageProps extends IAppPropsWithRoute {
};

function ReasonsForDelayPage(props: ViewCustomersPageProps): JSX.Element {
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(showNavbar(true));
    }, [])

    return (
        <>
            <AddEditReasonWidget reasonType={REASON_TYPE.DELAY} />
        </>
    );
}

export default React.memo(withRouter(ReasonsForDelayPage));